const elementStyles = {
  base: {
    color: "#000",
    fontWeight: 500,
    fontFamily: "Quicksand, Open Sans, Segoe UI, sans-serif",
    fontSize: "16px",
    fontSmoothing: "antialiased",
    ":focus": {
      color: "#424770",
    },
    "::placeholder": {
      color: "#9BACC8",
    },
    ":focus::placeholder": {
      color: "#CFD7DF",
    },
  },
  invalid: {
    color: "#000",
    ":focus": {
      color: "#FA755A",
    },
    "::placeholder": {
      color: "#FFCCA5",
    },
  },
};

const elementClasses = {
  focus: "focus",
  empty: "empty",
  invalid: "invalid",
  complete: "complete",
};

function ShowCardError(errorMessage) {
  const existingError = document.getElementById("card-error-snackbar");
  if (existingError) {
    existingError.remove();
  }

  const modalTitle = document.querySelector(".modal-title");
  if (!modalTitle) return;

  const template = document.getElementById("card-error-template");
  if (!template) {
    console.error("Card error template not found");
    return;
  }

  const errorDiv = template.querySelector(".snackbar-container").cloneNode(true);
  errorDiv.id = "card-error-snackbar";
  
  const messageElement = errorDiv.querySelector("[data-error-message]");
  if (messageElement) {
    messageElement.textContent = errorMessage;
  }

  modalTitle.parentNode.insertBefore(errorDiv, modalTitle.nextSibling);
}

async function PopulateStripeForm(dotnetHelper, stripeKey) {
  if (!stripeKey) {
    console.error("Stripe key is missing or invalid.");
    return;
  }

  let stripe = Stripe(stripeKey);
  let elements = stripe.elements();

  let cardNumber = elements.create("cardNumber", {
    style: elementStyles,
    classes: elementClasses,
    showIcon: true,
  });
  cardNumber.mount("#card-number-element");

  let cardExpiry = elements.create("cardExpiry", {
    style: elementStyles,
    classes: elementClasses,
  });
  cardExpiry.mount("#card-expiry-element");

  let cardCvc = elements.create("cardCvc", {
    style: elementStyles,
    classes: elementClasses,
  });
  cardCvc.mount("#card-cvc-element");

  let form = document.getElementById("payment-form");
  let submitButton = document.getElementById("submit-button");

  function CleanupStripeForm() {
    const existingError = document.getElementById("card-error-snackbar");
    if (existingError) {
      existingError.remove();
    }

    try {
      cardNumber.blur();
      cardExpiry.blur();
      cardCvc.blur();
    } catch (e) {
    }
  }

  const modal = document.querySelector('[role="dialog"]');
  if (modal) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const isHidden =
            modal.classList.contains("hidden") ||
            modal.style.display === "none";
          if (isHidden) {
            CleanupStripeForm();
          }
        }
      });
    });
    observer.observe(modal, {
      attributes: true,
      attributeFilter: ["class", "style"],
    });

    const parentObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.removedNodes.forEach((node) => {
          if (node === modal) {
            CleanupStripeForm();
            observer.disconnect();
            parentObserver.disconnect();
          }
        });
      });
    });
    if (modal.parentNode) {
      parentObserver.observe(modal.parentNode, { childList: true });
    }
  }

  form.addEventListener("submit", async function (event) {
    event.preventDefault();
    submitButton.disabled = true;
    stripe
      .createPaymentMethod({
        type: "card",
        card: cardNumber,
        billing_details: {},
      })
      .then(async function (result) {
        if (result.error) {
          submitButton.disabled = false;
          ShowCardError(
            result.error.message ||
              "Invalid card details. Please check and try again."
          );
        } else {
          try {
            const attachResult = await dotnetHelper.invokeMethodAsync(
              "AttachPaymentToOrg",
              result.paymentMethod.id
            );
            console.log('Attach result:', attachResult);
            
            if (
              !attachResult ||
              attachResult === false ||
              attachResult === null ||
              (typeof attachResult === "object" &&
                Object.keys(attachResult).length === 0)
            ) {
              submitButton.disabled = false;
              ShowCardError("Your card was declined. Please try again.");
              return;
            }
          } catch (error) {
            submitButton.disabled = false;
            
            let errorMessage = "Your card was declined. Please try again.";

            if (typeof error === "string") {
              errorMessage = error;
            } else if (error?.message) {
              const msg = error.message;
              const match = msg.match(/System\.Exception:\s*(.+?)(?:\s+at\s+|$)/);
              if (match && match[1]) {
                errorMessage = match[1].trim();
              } else {
                const firstLine = msg.split('\n')[0].split(' at ')[0];
                if (firstLine && firstLine.includes('Exception:')) {
                  errorMessage = firstLine.split('Exception:')[1].trim();
                } else if (firstLine) {
                  errorMessage = firstLine.trim();
                }
              }
            }
            ShowCardError(errorMessage);
          }
        }
      })
      .catch(function (error) {
        submitButton.disabled = false;
        console.error("Stripe error:", error);
        ShowCardError(
          "Unable to process your card. Please check your details and try again."
        );
      });
  });
}
